"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnhancedRootMovieClip = void 0;
function isEnhancedRootMovieClip(clip) {
    return typeof clip.clearAllSoundStreams === "function";
}
exports.isEnhancedRootMovieClip = isEnhancedRootMovieClip;
//# sourceMappingURL=interfaces.js.map
//# sourceMappingURL=module.js.map